import { Download, FileText } from "lucide-react";

import { FilePreview } from "@/components/FilePreview";
import { API } from "@/lib/api";

const FILE_KIND_LABELS = { lab: "Lab", receta_anterior: "Receta previa", payment_proof: "Comprobante de pago" };

function DocViewer({ file }) {
  if (!file)
    return (
      <div className="h-[480px] flex items-center justify-center text-sm text-muted-foreground border rounded-xl bg-secondary/50">
        Selecciona un documento para verlo
      </div>
    );
  return (
    <div>
      <a
        href={`${API}/files/${file.file_id}`}
        target="_blank"
        rel="noreferrer"
        className="inline-flex items-center gap-1 text-xs text-primary hover:underline mb-2"
        data-testid="doc-open-new-tab"
      >
        Abrir "{file.original_filename}" en pestaña nueva ↗
      </a>
      <FilePreview file={file} />
    </div>
  );
}

export function DocumentsPanel({ req, selectedFile, onSelect, completed }) {
  return (
    <div className="border rounded-2xl bg-white p-5">
      <p className="font-heading font-semibold mb-3">Documentos ({req.files?.length || 0})</p>
      <div className="flex flex-wrap gap-2 mb-4">
        {req.files?.map((f) => (
          <button
            key={f.file_id}
            onClick={() => onSelect(f)}
            data-testid={`pro-file-tab-${f.file_id}`}
            className={`inline-flex items-center gap-1.5 text-xs font-semibold rounded-full px-3 py-1.5 border transition-colors duration-200 ${
              selectedFile?.file_id === f.file_id ? "bg-primary text-white border-primary" : "hover:bg-secondary"
            }`}
          >
            <FileText className="h-3.5 w-3.5" strokeWidth={1.5} />
            {FILE_KIND_LABELS[f.kind] || "Doc"} · {f.original_filename.slice(0, 22)}
          </button>
        ))}
      </div>
      <DocViewer file={selectedFile} />
      <div className="mt-4 border-t pt-3">
        <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground mb-2">
          Descargar documentos
        </p>
        <div className="flex flex-wrap gap-2">
          {req.files?.map((f) => (
            <a
              key={f.file_id}
              href={`${API}/files/${f.file_id}?dl=1`}
              className="inline-flex items-center gap-1.5 text-xs font-semibold rounded-full px-3 py-1.5 border hover:bg-secondary transition-colors duration-200"
              data-testid={`download-file-${f.file_id}`}
            >
              <Download className="h-3.5 w-3.5" strokeWidth={1.5} />
              {f.original_filename}
            </a>
          ))}
          {completed && (
            <a
              href={`${API}/requests/${req.id}/pdf?dl=1`}
              className="inline-flex items-center gap-1.5 text-xs font-semibold rounded-full px-3 py-1.5 bg-primary text-white border border-primary hover:opacity-90 transition-opacity duration-200"
              data-testid="pro-download-final-pdf"
            >
              <Download className="h-3.5 w-3.5" strokeWidth={1.5} />
              Receta firmada (PDF)
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
